export const TRANSITION_DELAY_BETWEEN_IMAGE_AND_FIRST_LINE = 100;
export const TRANSITION_DELAY_BETWEEN_LINES = 180;

export const TILES_FORMAT = 'webp';
export const TILES_TYPE = 'digital_original';
